import RestApi from './../../api/rest-api-client'
const srvcEndpoint = '/push_messages'
export default {
  search: async (req, opts) => RestApi.request('GET', srvcEndpoint, req, opts),
  get: async (id, req, opts) =>
    RestApi.request('GET', srvcEndpoint, id, req, opts),

  // BST-only. Carries an explicit recipient user_id plus a client_send_id that
  // makes the send idempotent — a double click or retry returns the original
  // record rather than firing a second notification.
  send: async (data, opts) => RestApi.request('POST', srvcEndpoint, data, opts),

  // The agent tapped the OS notification for this message. Reported by the page
  // rather than the service worker, which has neither a Firebase auth token nor
  // an App Check token to call an authenticated endpoint with.
  reportClick: async (id, deviceUid, opts) =>
    RestApi.request(
      'POST',
      srvcEndpoint,
      { device_uid: deviceUid || null },
      {
        ...(opts || {}),
        endpoint: `${srvcEndpoint}/${id}/clicked`,
      }
    ),
}
